import { render, staticRenderFns } from "./oss-uploader.vue?vue&type=template&id=be73bae0"
import script from "./oss-uploader.vue?vue&type=script&lang=js"
export * from "./oss-uploader.vue?vue&type=script&lang=js"
import style0 from "./oss-uploader.vue?vue&type=style&index=0&id=be73bae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports